export default function DataTable({ columns, rows, maxRows }) {
  const visibleRows = maxRows ? rows.slice(0, maxRows) : rows;

  return (
    <div className="table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => <th key={column.key}>{column.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {visibleRows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="muted-cell">No records found</td>
            </tr>
          ) : visibleRows.map((row, rowIndex) => (
            <tr key={`${rowIndex}-${JSON.stringify(row)}`}>
              {columns.map((column) => (
                <td key={column.key} className={column.align === 'right' ? 'align-right' : ''}>
                  {column.render ? column.render(row[column.key], row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
